// Componente per la gestione ToolbarInline
import React from 'react';
import PropTypes from 'prop-types';
import { set, get } from './Storage';
import axios from 'axios';
// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'ToolbarInlineComponent';
var styles = AppSettings.styles;

class ToolbarInline extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTab = this.handleTab.bind(this);
        this.refreshBalance = this.refreshBalance.bind(this);
        this.openUtilityUser = this.openUtilityUser.bind(this);

        this.state = {
            balance: "",
            bonusBalance:"",
            showBalance: false,
            fido: "",
        }

        this.handleToggleBalance = this.handleToggleBalance.bind(this);
    }

    componentDidMount() {
        if (AppSettings['balanceOpened'] && AppSettings.device != "mobile") {
            let data = this.context.getExternalToolbarBalance();
            if(data == null){
                this.refreshBalance();
            }
            else{
                this.setState({
                    balance: data.balance,
                    bonusBalance: data.bonusBalance,
                    fido: data.fido,
                    showBalance: true
                });
            }
        }
    }
    
    componentWillReceiveProps(props){
        if(props.balance!="" && this.state.balance != props.balance){
            this.setState({
                balance: props.balance,
                bonusBalance:props.bonusBalance,
                showBalance: true,
                fido: this.props.fido,
            });
        }
    }

    handleTab(tab, event) {
        this.props.handleTab(tab);
    }

    handleLogout(){
        //se presente effettuo il logut silente, altrimenti quello classico con redirec
        if(window._site.login){
            window._site.login.logout(AppSettings["urlLogout"]);
        }
        else{
            document.location.href = AppSettings.urlLogout;
        }

    }

    // mostra/nascondi il saldo
    handleToggleBalance() {
        //var currentValueBalance = AppSettings['balanceOpened'];
        if (this.state.showBalance) {
            this.setState({
                showBalance: false,
                balance: "---",
                bonusBalance:"---",
                fido: '---',
            });
            this.context.setStatusBalance(false);
            try{
                // document.getElementById("mg-pvr-balance").checked = false;
                document.querySelectorAll("[data-ub-balance]").forEach(function(el){ el.innerHTML = "---" });
                document.querySelectorAll("[data-ub-bonus]").forEach(function(el){ el.innerHTML = "---" });
                document.querySelectorAll("[data-ub-min-balance]").forEach(function(el){ el.innerHTML = '---' });
                }
                catch(e){}
        }
        else {
            this.refreshBalance();
            this.context.setStatusBalance(true);
        }
    }
    
    refreshBalance() {
       
        this.setState({
            showBalance: true,
            balance: "---",
            bonusBalance:"---"
        });
        var balance = "---";
        var bonusBalance="0";
        var fido = "";
        var url = AppSettings['env'].urlUserBoxGetBalance;
        this.context.setBalanceData(null);
        axios.get(url)
            .then(({ data, status, statusText }) => {
                this.context.setExternalToolbarBalance(data);
                if (data.errors.length == 0) {
                    this.context.setBalanceData(data);
                    balance = data.balance;
                    if(data.bonusBalance !=null){
                        bonusBalance = data.bonusBalance;
                    } 
                    fido = data.fidoStr;
                    try {
                        document.querySelectorAll("[data-ub-balance]").forEach(function (el) { el.innerHTML = balance });
                        document.querySelectorAll("[data-ub-bonus]").forEach(function(el){ el.innerHTML = bonusBalance });
                        document.querySelectorAll("[data-ub-min-balance]").forEach(function(el){ el.innerHTML = fido });
                    }
                    catch (e) { }
                }
                this.setState({
                    balance: balance,
                    bonusBalance:bonusBalance,
                    showBalance: true,
                    fido: fido
                });
            })

            .catch((error) => {
                this.setState({
                    balance: "---",
                    bonusBalance:"---",
                    showBalance: true
                });
            });
    }
    
    openUtilityUser(){
        let elm = document.querySelectorAll('.ub-active');
        if(elm.length > 0){
            this.props.handleTab(false);
        }
        else{
            this.props.handleTab('profile');
        }
    }

    render() {
        if(!AppSettings.isauthenticated) return null;

        //elimino il loading
        var userElement = document.getElementById("mg-website--user");
        if(userElement != null) userElement.innerHTML = ""

        let cumulativeCountNotification = this.props.countNews + this.props.countCoupon;

        let classes = ["info-balance"];

        (!this.state.showBalance && classes.push("balance-hidden") )

        return(
                <div id="wrap-logged" className="user-logged">
                    <div id="user-box-profilo" className="user-logged--info">
                        <span title="Conto gioco" className="info-profilo" onClick={this.handleTab.bind(this, "profile")}>
                            <i className="info-profilo_icona"></i>{ cumulativeCountNotification > 0 ? <span className="info-profilo_counter">{cumulativeCountNotification}</span> : ""}{AppSettings.device !== "mobile" && AppSettings.balanceOpened ?<span className="info-profilo_saldo">{this.state.balance}</span>:""}</span>
                        <div>
                            <div className="info-username">
                                <span className="info-username_nome">Ciao <strong className="data-hj-suppress">{this.props.data.username}</strong></span>
                            </div>
                       
                            <div className={classes.join(" ")}>
                                {this.state.showBalance ? 
                                        <i title='Nascondi' className="info-balance_control control-hide" onClick={this.handleToggleBalance}></i> 
                                        : 
                                        <i title='Mostra' className="info-balance_control control-show" onClick={this.handleToggleBalance}></i>
                                }
                    
                                <div className="info-balance_wrap">                                            
                                    <div className="info-balance_saldo">
                                        <span>Saldo:</span>
                                        <strong data-ub-balance="0">{this.state.showBalance ? this.state.balance: "---"}</strong>
                                    </div>
                                    {!AppSettings["isPartner"] ?
                                    <div className="info-balance_saldo saldo-bonus">
                                        <span>Bonus:</span>
                                        <strong data-ub-bonus="0">{this.state.showBalance ? this.state.bonusBalance: "---"}</strong>
                                    </div>
                                    : null}
                                </div>
                                <i title="Aggiorna" className="info-balance_refresh" onClick={this.refreshBalance}></i>      
                            </div>
                        </div>
                    </div>
               
                    <div className="user-logged--wallet">
                        <div onClick={this.context.openDepositToolList} className="wallet-action" id="wallet-action_ricarica" title="Ricarica">Ricarica</div>
                        <div onClick={this.context.openWithdrawalToolList} className="wallet-action" id="wallet-action_preleva" title="Preleva">Preleva</div>
                    </div> 
                    
                    <div className="user-logged--utility">
                        <div title="Conto gioco" id="utility-user" className="utility-box" onClick={this.openUtilityUser}>
                            <i className="utility-box_icona"></i>
                            { cumulativeCountNotification > 0 ? <span className="utility-box_counter">{cumulativeCountNotification}</span> : ""}
                        </div>
                        <div title="Ricarica" id="utility-ricarica" className="utility-box" onClick={this.context.openDepositToolList}><i className="utility-box_icona"></i></div>
                        {this.props.countNews > 0 ?<div title="News" id="utility-news" className="utility-box" onClick={this.handleTab.bind(this, "news")}><i className="utility-box_icona"></i><span className="utility-box_counter">{this.props.countNews}</span></div> : null }
                        {this.props.countCoupon > 0 ? <div title="Coupon" id="utility-coupon" className="utility-box" onClick={this.handleTab.bind(this, "coupon")} ><i className="utility-box_icona"></i><span className="utility-box_counter">{this.props.countCoupon}</span></div> : null}
                        {AppSettings["isPartner"] ?  <div title="Pvr dashboard" id="utility-pvr_dashboard" className="utility-box" onClick={() => {location.href = "/pvr-dashboard"}}><i className="utility-box_icona"></i></div>: null}
                        {!AppSettings["isPartner"] && AppSettings["komodo"] != null ?  <div title="Komodo" id="utility-komodo" className="utility-box" onClick={() => {location.href = "/komodo"}}><i className="utility-box_icona"></i></div>: null}
                        {this.props.countMission > 0 ? <div title="Missioni" id="utility-mission" className="utility-box" onClick={this.context.openMissionsToolList} ><i className="utility-box_icona"></i><span className="utility-box_counter user-box_missioncounter">{this.props.countMission}</span></div> : null}                        
                        <div title="Esci" id="utility-logoff" className="utility-box" onClick={this.handleLogout}><i className="utility-box_icona"></i></div>
                    </div> 
                    
                </div> 
        )

    }
}

ToolbarInline.displayName = componentName;

// PropTypes validation
ToolbarInline.propTypes = {
    countNews: PropTypes.number,
    countCoupon: PropTypes.number,
    balance: PropTypes.string,
    bonusBalance:PropTypes.string,
    countMission: PropTypes.number,
};

// default props
ToolbarInline.defaultProps = {
    switchToolbar: function () {
    }
};

ToolbarInline.contextTypes = {
    openDepositToolList: PropTypes.func,
    openWithdrawalToolList: PropTypes.func,
    openMissionsToolList: PropTypes.func,
    setExternalToolbarBalance:PropTypes.func,
    getExternalToolbarBalance:PropTypes.func,
    setStatusBalance:PropTypes.func,
    setBalanceData: PropTypes.func
}

export default ToolbarInline;
